export const Images = <const>{
  acmeLogo: 'acme/logo.svg',
  adpLogo: 'adp/logo.svg',
  afasLogo: 'afas/logo.svg',
  appicalLogo: 'appical/logo.svg',
  arbeitnowLogo: 'arbeitnow/logo.svg',
  bambooLogo: 'bamboo/logo.svg',
  bryqLogo: 'bryq/logo.svg',
  checkrLogo: 'checkr/logo.svg',
  codilityLogo: 'codility/logo.svg',
  codilityCodeLive: 'codility/code-live.svg',
  devSkillerLogo: 'dev_skiller/logo.svg',
  docuSignLogo: 'docu_sign/logo.svg',
  enboarderLogo: 'enboarder/logo.svg',
  eSkillLogo: 'eskill/logo.svg',
  gfeaLogo: 'gfea/logo.svg',
  gustoLogo: 'gusto/logo.svg',
  hackerRankLogo: 'hacker_rank/logo.svg',
  harverLogo: 'harver/logo.svg',
  helloSignLogo: 'hello_sign/logo.svg',
  hibobLogo: 'hibob/logo.svg',
  hotelprofessionalsFullLogo: 'hotelprofessionals/logo-full.svg',
  hotelprofessionalsLogo: 'hotelprofessionals/logo.svg',
  hr2dayLogo: 'hr2day/logo.svg',
  imochaLogo: 'imocha/logo.svg',
  indeedLogo: 'indeed/logo.svg',
  jacandoLogo: 'jacando/logo.svg',
  jitsiLogo: 'jitsi/logo.svg',
  kiwiHrLogo: 'kiwi_hr/logo.svg',
  kununuLogo: 'kununu/logo.svg',
  loketLogo: 'loket/logo.svg',
  luccaLogo: 'lucca/logo.svg',
  nmbrsLogo: 'nmbrs/logo.svg',
  officientLogo: 'officient/logo.svg',
  personioLogo: 'personio/logo.svg',
  predictiveIndexLogo: 'predictive_index/logo.svg',
  signRequestLogo: 'sign_request/logo.svg',
  sympaLogo: 'sympa/logo.svg',
  teamsLogo: 'teams/logo.svg',
  testDomeLogo: 'test_dome/logo.svg',
  tyomarkkinatoriLogo: 'tyomarkkinatori/logo.svg',
  werkenInEenHotelLogo: 'werken_in_een_hotel/logo.svg',
  werkenInEenHotelFullLogo: 'werken_in_een_hotel/logo-full.svg',
  wonderkindLogo: 'wonderkind/logo.svg',
  zoomLogo: 'zoom/logo.svg',
};
